export enum ShipmentListFiltersETASources {
  ShipsGo = 'SHIPS_GO',
  ML = 'ML',
  BestFit = 'BESTFIT',
}
